// Copyright (C) 2022 TANNER AG

import React, { useState } from "react";
import Section from "../../../../components/Section";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { AddCircleIcon } from "../../../../components/icons/MANIcons";
import { Project } from "../../../../graphql";
import Link from "@mui/material/Link";
import ProjectNoteEdit from "./ProjectNoteEdit";
import useTranslation from "../../../../hooks/usetranslation";

type Props = {
    project?: Pick<Project, "id" | "notes">;
};

const ProjectNote: React.FC<Props> = ({ project }) => {
    const [edit, setEdit] = useState(false);

    const handleOpenEdit = () => setEdit(true);
    const handleCloseEdit = () => setEdit(false);
    const { t } = useTranslation();
    return (
        <Section sx={{ mb: 4 }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ pb: 1 }}>
                {t("notes")}
            </Typography>
            {edit ? (
                <ProjectNoteEdit project={project} onClose={handleCloseEdit} />
            ) : (
                <>
                    {project?.notes ? (
                        <Typography>
                            <Typography
                                sx={{ display: "inline" }}
                                dangerouslySetInnerHTML={{
                                    __html: project?.notes?.replaceAll("\n", "<br/>") ?? ""
                                }}
                            />
                            <Link sx={{ pl: 1 }} onClick={handleOpenEdit}>
                                {t("edit")}
                            </Link>
                        </Typography>
                    ) : (
                        <Button onClick={handleOpenEdit} startIcon={<AddCircleIcon color="secondary" />}>
                            {t("personal_note")}
                        </Button>
                    )}
                </>
            )}
        </Section>
    );
};

export default ProjectNote;
